import { DropdownItem, DropdownItemProps } from 'reactstrap';

import './DropdownItem.module.scss';

export const ProxyDropdownItem = ({
  testId = 'gafe-drop-down-item',
  ...restProps
}: DropdownItemProps) => <DropdownItem data-testid={testId} {...restProps} />;
